import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  Card,
  FormCheck,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";

function CustomFieldData(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const RouteTypeId = useParams();
  const [typeId, setTypeId] = useState(Number(RouteTypeId.RouteTypeId) || 0);

  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [typeExist, setTypeExist] = useState(null);

  const [typeDetails, setTypeDetails] = useState(null);
  const [types, setTypes] = useState([]);
  const [addModalShow, SetAddModalShow] = useState(false);
  const [AddToDb, setAddToDb] = useState({
    CustomFieldDataId: 0,
    CustomFieldTypeId: 0,
    Text: "",
    IsPublished: false,
  });

  const [UpdateToDb, setUpdateToDb] = useState({
    CustomFieldDataId: 0,
    CustomFieldTypeId: 0,
    Text: "",
    IsPublished: false,
  });
  const [updateModalShow, setUpdateModalShow] = useState(0);

  // Get Types
  const GetTypeDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "CustomFieldType/GetCustomFieldTypeDetails/" + typeId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setTypeDetails(result);
    } else {
      setTypeExist(false);
    }
  };

  // Get Types
  const GetTypes = async () => {
    setLoader(true);
    let response = await fetch(
      Variables.API_URL + "CustomFieldType/GetCustomFieldTypes",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setTypes(result);
    }
    setLoader(false);
  };

  // Get Data
  const GetData = async () => {
    setLoader(true);
    let response = await fetch(
      Variables.API_URL + "CustomFieldData/GetCustomFieldTypeData/" + typeId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setData(result);
      setFilteredData(result);
      setTypeExist(true);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = data.filter((x) => {
      return x.Text.toLowerCase().search(value) !== -1;
    });
    setFilteredData(result);
  };

  // Clear Add To Db
  function ClearAddToDb() {
    SetAddModalShow(false);
    setAddToDb({
      CustomFieldDataId: 0,
      CustomFieldTypeId: 0,
      Text: "",
      IsPublished: false,
    });
  }

  // Set Add To Db
  function SetAddToDb() {
    SetAddModalShow(true);
    setAddToDb({
      CustomFieldDataId: 0,
      CustomFieldTypeId: 0,
      Text: "",
      IsPublished: false,
    });
  }

  // Set Update ToDb
  function SetUpdateToDb(id, name, isPublished) {
    setUpdateModalShow(id);
    setUpdateToDb({
      CustomFieldTypeId: 0,
      Text: "",
      IsPublished: false,
    });
  }

  // Clear data Update To Db
  function ClearUpdateToDb() {
    setUpdateModalShow(0);
    setUpdateToDb({
      CustomFieldDataId: 0,
      CustomFieldTypeId: 0,
      Text: "",
      IsPublished: false,
    });
  }

  // handle Add Inputs
  function handleAddInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("TextToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("TextToAdd");
      element.classList.remove("is-invalid");
    }
    setAddToDb((prevState) => ({
      ...prevState,
      ["Text"]: value,
    }));
  }

  // handle Add type Inputs
  function handleAddTypeInputs(e) {
    const { value } = e.target;
    var element;
    if (value === 0) {
      element = document.getElementById("TypeToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("TypeToAdd");
      element.classList.remove("is-invalid");
    }
    setAddToDb((prevState) => ({
      ...prevState,
      ["CustomFieldTypeId"]: value,
    }));
  }

  // Check input validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (AddToDb.Text === null || AddToDb.Text === "") {
      element = document.getElementById("TextToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }
    // if (AddToDb.CustomFieldTypeId === null || AddToDb.CustomFieldTypeId === 0) {
    //   element = document.getElementById("TypeToAdd");
    //   element.classList.add("is-invalid");
    //   hasError = true;
    // }

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Data
  const AddNewData = async () => {
    var Valid = IsValidToAdd();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "CustomFieldData/AddCustomFieldData",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            CustomFieldDataId: 0,
            CustomFieldTypeId: typeId,
            Text: AddToDb.Text,
            IsPublished: true,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModalShow(false);
        setAddToDb({
          CustomFieldDataId: 0,
          CustomFieldTypeId: 0,
          Text: "",
          IsPublished: false,
        });
        GetData();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Required Input", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // handle Updatee Inputs
  function handleUpdateInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("TextToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("TextToUpdate");
      element.classList.remove("is-invalid");
    }
    setUpdateToDb((prevState) => ({
      ...prevState,
      ["Text"]: value,
    }));
  }

  // handle Updatee Inputs
  function handleUpdateTypeInputs(e) {
    const { value } = e.target;
    var element;
    if (value === 0) {
      element = document.getElementById("TypeToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("TypeToUpdate");
      element.classList.remove("is-invalid");
    }
    setUpdateToDb((prevState) => ({
      ...prevState,
      ["CustomFieldTypeId"]: value,
    }));
  }

  // Handle Update IsPublished
  const HandleUpdateIsPublished = () => {
    if (UpdateToDb.IsPublished === true) {
      setUpdateToDb((prevState) => ({
        ...prevState,
        IsPublished: false,
      }));
    } else {
      setUpdateToDb((prevState) => ({
        ...prevState,
        IsPublished: true,
      }));
    }
  };

  // Check input validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (UpdateToDb.Text === null || UpdateToDb.Text === "") {
      element = document.getElementById("TextToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      UpdateToDb.CustomFieldTypeId === null ||
      UpdateToDb.CustomFieldTypeId === 0
    ) {
      element = document.getElementById("TypeToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Update Data
  const UpdateData = async () => {
    var Valid = IsValidToUpdate();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "CustomFieldData/UpdateCustomFieldData",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            CustomFieldDataId: UpdateToDb.CustomFieldDataId,
            CustomFieldTypeId: typeId,
            Text: UpdateToDb.Text,
            IsPublished: UpdateToDb.IsPublished,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setUpdateModalShow(0);
        setUpdateToDb({
          CustomFieldDataId: 0,
          CustomFieldTypeId: 0,
          Text: "",
          IsPublished: false,
        });
        GetData();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Fill All required Inputs", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
  

    GetTypeDetails();
    GetData();
    GetTypes();
  }, []);

  useEffect(() => {
    GetTypes();
  }, [typeDetails]);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {typeExist == null && "Loading ..."}
                  {typeExist == false && "Type Id Not Exist"}
                  {typeExist == true && typeDetails.Text + " --> Data List"}
                </h4>
              </div>
              {typeExist == true &&
                Permissions.ManageCustomFieldsType === true && (
                  <Button variant="primary" onClick={() => SetAddToDb()}>
                    Add New Custom Field Data
                  </Button>
                )}
            </Card.Header>

            <Card.Body className="px-0">
              {typeExist == false ? (
                <div className="alert alert-danger m-4" role="alert">
                  Content Not Exist...{" "}
                  <a
                    href="#"
                    className="alert-link"
                    onClick={() => navigate("/CustomFieldsType")}
                  >
                    Back To Contents List
                  </a>
                </div>
              ) : (
                <>
                  <Form.Control
                    id="Search"
                    name="Search"
                    placeholder="Search"
                    type="text"
                    className="allignCenter"
                    onChange={handleSearch}
                  />
                  {loader === true ? (
                    <CustomSnipper />
                  ) : (
                    <div className="table-responsive">
                      <table
                        id="user-list-table"
                        className="table table-striped"
                        role="grid"
                        data-toggle="data-table"
                      >
                        <thead>
                          <tr className="ligth">
                            <th></th>
                            <th>Custom Field Data Name</th>
                            <th>IsPublished</th>
                            <th min-width="100px">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredData.map((tdata, index) => (
                            <tr key={index}>
                              <td className="text-center">{index + 1}</td>
                              <td>{tdata.Text}</td>
                              <td>
                                <span
                                  className={
                                    tdata.IsPublished === false
                                      ? "badge bg-danger"
                                      : "badge bg-success"
                                  }
                                >
                                  {tdata.IsPublished === false
                                    ? "Unpublished"
                                    : "Published"}
                                </span>
                              </td>
                              <td>
                                {Permissions.ManageCustomFieldData === true && (
                                  <div className="flex align-items-center list-user-action">
                                    <Link
                                      className="btn btn-sm btn-icon btn-success"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title=""
                                      data-original-title="Edit"
                                      to={"#"}
                                      onClick={() => {
                                        setUpdateToDb({
                                          CustomFieldDataId:
                                            tdata.CustomFieldDataId,
                                          CustomFieldTypeId:
                                            tdata.CustomFieldTypeId,
                                          Text: tdata.Text,
                                          IsPublished: tdata.IsPublished,
                                        });
                                        setUpdateModalShow(
                                          tdata.CustomFieldDataId
                                        );
                                      }}
                                    >
                                      <span className="btn-inner">
                                        <svg
                                          width="20"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            d="M15.1655 4.60254L19.7315 9.16854"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </span>
                                    </Link>{" "}
                                    <Modal
                                      show={
                                        updateModalShow ==
                                        tdata.CustomFieldDataId
                                      }
                                      onHide={() => ClearUpdateToDb()}
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title as="h5">
                                          Update Type : {UpdateToDb.Text}
                                        </Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        <Row>
                                          <Form.Group className="col-md-12 form-group">
                                            <Form.Label htmlFor="lname">
                                              Title:
                                            </Form.Label>
                                            <Form.Control
                                              id="TextToUpdate"
                                              name="TextToUpdate"
                                              placeholder="Text"
                                              type="text"
                                              value={UpdateToDb.Text}
                                              onChange={handleUpdateInputs}
                                            />
                                          </Form.Group>
                                        </Row>

                                        <Row>
                                          <Form.Group className="col-lg-6 col-md-6 col-sm-12 form-group">
                                            <Form.Label htmlFor="fname">
                                              Is Published :
                                            </Form.Label>
                                            <Form.Check className="mb-3 form-check">
                                              <FormCheck.Input
                                                type="checkbox"
                                                className=""
                                                id="IsPublishToUpdate"
                                                checked={UpdateToDb.IsPublished}
                                                onChange={(e) =>
                                                  HandleUpdateIsPublished()
                                                }
                                              />
                                              <FormCheck.Label
                                                className=""
                                                htmlFor="exampleCheck1"
                                              >
                                                Is Published
                                              </FormCheck.Label>
                                            </Form.Check>
                                          </Form.Group>
                                        </Row>
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={() => setUpdateModalShow(0)}
                                        >
                                          Close
                                        </Button>
                                        <Button
                                          variant="primary"
                                          onClick={() => UpdateData()}
                                        >
                                          Save changes
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <Modal show={addModalShow} onHide={() => ClearAddToDb()}>
                        <Modal.Header closeButton>
                          <Modal.Title as="h5">Add New Data</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Row>
                            <Form.Group className="col-md-12 form-group">
                              <Form.Label htmlFor="lname">Title:</Form.Label>
                              <Form.Control
                                id="TextToAdd"
                                name="TextToAdd"
                                placeholder="Title"
                                type="text"
                                value={AddToDb.Text}
                                onChange={handleAddInputs}
                              />
                            </Form.Group>
                          </Row>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={() => SetAddModalShow(false)}
                          >
                            Close
                          </Button>
                          <Button
                            variant="primary"
                            onClick={() => AddNewData()}
                          >
                            Save changes
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default CustomFieldData;
